import { __awaiter, __generator } from "tslib";
import { initialize } from './i18n-initialize';
import { initFeatBit } from '../lib/featbit';
export var generateAIChatSessionId = function () {
    return "chat_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
};
export function newHomeConfig(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.needInitFeatBit, needInitFeatBit = _c === void 0 ? true : _c, _d = _b.needInitI18n, needInitI18n = _d === void 0 ? true : _d;
    return __awaiter(this, void 0, void 0, function () {
        var _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    window.isNewHome = true;
                    window.CURRENT_AICHAT_SESSIONID = generateAIChatSessionId();
                    if (!needInitFeatBit) return [3, 4];
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4, initFeatBit()];
                case 2:
                    _f.sent();
                    return [3, 4];
                case 3:
                    _e = _f.sent();
                    return [3, 4];
                case 4:
                    if (IS_HSFK || !needInitI18n)
                        return [2, Promise.resolve()];
                    return [2, initialize()];
            }
        });
    });
}
